import React from "react";
import { View, Text, StyleSheet, Font } from "@react-pdf/renderer";



Font.register({
  family: "Open Sans",
  fonts: [
    { src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf", fontWeight: "normal" },
    { src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-700.ttf", fontWeight: "bold" }
  ]
});


// Define styles using React PDF's StyleSheet
const styles = StyleSheet.create({
  container: {
    padding: 6,
    backgroundColor: "white", // Set background to white
  },
  table: {
    width: "100%", // Full-width table
    // border: "1px solid #ddd", // Table border for styling
    borderCollapse: "collapse", // Ensure borders are collapsed
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
    // borderBottom: "1px solid #ddd", // Border between rows
    padding: "4px 0",
  },
  tableCell: {
    padding: 2,
    fontSize: 8,
    color: "#333",
  },
  labelCell: {
    fontFamily: "Open Sans", // Must match registered name
    fontWeight: "bold", // Ensures the bold variant is used

    fontSize: 8,
    width: "85%", // 50% width for the label column
    textAlign: "left", // Align label text to the left
    // fontWeight: 900, // Use "bold" or "700"
    color: "#6B7280", // Color for the label text
  },
  valueCell: {
    fontFamily: "Open Sans", // Must match registered name
    fontWeight: "bold", // Ensures the bold variant is used

    fontSize: 8,
    width: "85%", // 50% width for the value column
    textAlign: "right", // Align value text to the right
    // fontWeight: 900, // Use "bold" or "700"

  },
});

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// Custom component to display investor details in a table format
const InvestorDetailsDisplayOnPDF = ({ details }) => {
  return (
    <View style={styles.container}>
      {/* Table Structure */}
      <View style={styles.table}>
        {/* First Row */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.labelCell]}>Investor Name:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.name || "N/A"}
          </Text>
          <View style={{ width: 50 }} />
          <Text style={[styles.tableCell, styles.labelCell]}  >Email Id:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.user_email || "N/A"}
          </Text>

        </View>

        {/* Second Row */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.labelCell]}>Address:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.address || "N/A"}
          </Text>
          <View style={{ width: 50 }} />
          <Text style={[styles.tableCell, styles.labelCell]}  >PAN:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}  >
            {details?.pan_number || "N/A"}
          </Text>


        </View>

        {/* Third Row */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.labelCell]}>Phone No:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.mobile_number || "N/A"}
          </Text>
          <View style={{ width: 50 }} />
          <Text style={[styles.tableCell, styles.labelCell]}>CKYC No:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.ckyc_number || "N/A"}
          </Text>
        </View>

        {/* Fourth Row */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.labelCell]}>
            Date of Birth / Incorporation Date:
          </Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.date_of_birth
              ? formatDate(details?.date_of_birth)
              : "N/A"}
          </Text>
          <View style={{ width: 50 }} />
          <Text style={[styles.tableCell, styles.labelCell]}>Status:</Text>
          <Text style={[styles.tableCell, styles.valueCell]}>
            {details?.constitution || "N/A"}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default InvestorDetailsDisplayOnPDF;
